import { Box, Spinner, Image } from '@chakra-ui/react';

const GlobalLoader = () => {
  const boxStyles = {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  };

  const spinnerStyles = {
    width: '150px',
    height: '150px',
  };

  const imageStyles = {
    boxSize: '80px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <Box sx={boxStyles}>
      <Spinner sx={spinnerStyles} color="#027a3b" size="xl" thickness="4px" />
      <Image src="/loading-logo.svg" alt="Logo" sx={imageStyles} />
    </Box>
  );
};

export default GlobalLoader;
